import VueService from "../../service/VueService";
import CheckoutComponent from './checkout/Checkout.vue';
import AlertComponent from "./alert/Alert.vue";
import ToastComponent from "./alert/Toast.vue";
import MenuIcon from "./custom/MenuItem.vue";
import FooterMenu from "./custom/FooterMenuItem.vue";
import PasswordRecovery from "./auth/PasswordRecovery/PasswordRecovery.vue";

VueService.render(CheckoutComponent, '.checkout');
VueService.render(AlertComponent, '.alert-component');
VueService.render(ToastComponent, '.vue-toast-render');
VueService.render(MenuIcon, '.fast-auth');
VueService.render(FooterMenu, '.footer-menu-render');
VueService.render(PasswordRecovery, '.password-recovery-vue');